/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import ApiService from '@services/apiService';
import { boolToBit } from '@utils';

const LOAD_USER = 'p9/user/LOAD_USER';
const LOAD_USER_SUCCESS = 'p9/user/LOAD_USER_SUCCESS';
const LOAD_USER_ERROR = 'p9/user/LOAD_USER_ERROR';

const EDIT_USER = 'p9/user/EDIT_USER';
const EDIT_USER_SUCCESS = 'p9/user/EDIT_USER_SUCCESS';
const EDIT_USER_ERROR = 'p9/user/EDIT_USER_ERROR';

const SET_USER_IDLE_STATUS = 'SET_USER_IDLE_STATUS';

const initialState = {
  user: null,
  userPhoto: null,
  loading: true,
  error: null,
  isIdle: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USER:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case LOAD_USER_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: false,
        loading: false,
      };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload.user,
        },
        userPhoto: [
          ...state.userPhoto,
          ...action.payload.userPhoto,
        ],
      };
    case LOAD_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case SET_USER_IDLE_STATUS:
      return {
        ...state,
        isIdle: action.payload,
      };
    default:
      return state;
  }
};

const loadUser = () => dispatch => {
  dispatch({ type: LOAD_USER });
  return ApiService.User.getUser()
    .then(result => {
      dispatch({
        type: LOAD_USER_SUCCESS,
        payload: {
          user: boolToBit(result.data.agent),
          userPhoto: result.data.photos,
        },
      });
    })
    .catch(er => {
      console.error('Error: User loadUser', er);
      dispatch({ type: LOAD_USER_ERROR });
    });
};

const updateUser = newUserData => dispatch => {
  dispatch({ type: EDIT_USER });
  return ApiService.User.updateUser(newUserData)
    .then(() => {
      dispatch({
        type: EDIT_USER_SUCCESS,
        payload: {
          user: newUserData?.agent,
          userPhoto: newUserData?.photos || [],
        },
      });
    })
    .catch(er => {
      console.error('Error: User updateUser', er);
      dispatch({ type: EDIT_USER_ERROR });
    });
};

const setUserIdleStatus = status => dispatch => dispatch({
  type: SET_USER_IDLE_STATUS,
  payload: status,
});

export {
  loadUser,
  updateUser,
  setUserIdleStatus,
};
